export default __webpack_public_path__ + "static/media/BSM_Store_Icon.c232ee68.svg";